var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon9BlogCar2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.62 9.43c.2 0 .38.11.45.29l1.13 2.66c.15.36.47.61.87.66l3.98.44c.54.06.95.51.95 1.06v1.74c0 .34-.27.62-.61.62H2.7a.71.71 0 0 1-.71-.72v-1.7c0-.52.36-.96.88-1.05l1.96-.35c.36-.06.67-.31.81-.66l1.11-2.7a.5.5 0 0 1 .46-.3h7.4m0-2h-7.4c-1.03 0-1.93.62-2.31 1.57l-.92 2.21-1.47.26A3.05 3.05 0 0 0 0 14.48v1.7c0 1.5 1.22 2.72 2.71 2.72H21.4a2.62 2.62 0 0 0 2.6-2.62v-1.74a3.07 3.07 0 0 0-2.72-3.05l-3.45-.38-.92-2.17a2.48 2.48 0 0 0-2.29-1.51z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.46 17.22)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.97,
    cy: 0.97,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.11,
    cy: 0.97,
    r: 1
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.45 4.5h4.73"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+DQogIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+DQogICAgPHBhdGggZD0iTTE0LjYyIDkuNDNjLjIgMCAuMzguMTEuNDUuMjlsMS4xMyAyLjY2Yy4xNS4zNi40Ny42MS44Ny42NmwzLjk4LjQ0Yy41NC4wNi45NS41MS45NSAxLjA2djEuNzRjMCAuMzQtLjI3LjYyLS42MS42MkgyLjdhLjcxLjcxIDAgMCAxLS43MS0uNzJ2LTEuN2MwLS41Mi4zNi0uOTYuODgtMS4wNWwxLjk2LS4zNWMuMzYtLjA2LjY3LS4zMS44MS0uNjZsMS4xMS0yLjdhLjUuNSAwIDAgMSAuNDYtLjNoNy40bTAtMmgtNy40Yy0xLjAzIDAtMS45My42Mi0yLjMxIDEuNTdsLS45MiAyLjIxLTEuNDcuMjZBMy4wNSAzLjA1IDAgMCAwIDAgMTQuNDh2MS43YzAgMS41IDEuMjIgMi43MiAyLjcxIDIuNzJIMjEuNGEyLjYyIDIuNjIgMCAwIDAgMi42LTIuNjJ2LTEuNzRhMy4wNyAzLjA3IDAgMCAwLTIuNzItMy4wNWwtMy40NS0uMzgtLjkyLTIuMTdhMi40OCAyLjQ4IDAgMCAwLTIuMjktMS41MXoiIGZpbGw9IiMwMDAiIC8+DQogICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNC40NiAxNy4yMikiIHN0cm9rZT0iIzAwMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiPg0KICAgICAgPGNpcmNsZSBjeD0iLjk3IiBjeT0iLjk3IiByPSIxIi8+DQogICAgICA8Y2lyY2xlIGN4PSIxNC4xMSIgY3k9Ii45NyIgcj0iMSIvPg0KICAgIDwvZz4NCiAgICA8cGF0aCBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBkPSJNOC40NSA0LjVoNC43MyIvPg0KICA8L2c+DQo8L3N2Zz4NCg==";
export { SvgIcon9BlogCar2 as ReactComponent };